import React, { FC } from 'react';

import { MDText } from 'i18n-react';

import { preparedDisplayNames } from 'Utilities/helpers';

import { HighlightWord } from './HighlightWord';
import LocalTexts from './TrustpilotTexts.json';

import styles from './TrustpilotModal.scss';

const LocalT = new MDText(LocalTexts);

type TrustpilotModalProps = {
  body: string;
  title: string;
  vehicleMake?: string | null;
};

export const TrustpilotModal: FC<TrustpilotModalProps> = ({ body, title, vehicleMake = null }) => (
  <div className={styles.component}>
    <div className={styles.starRating}>{LocalT.translate('rating')}</div>
    <h3>
      <HighlightWord words={preparedDisplayNames(vehicleMake)}>{title}</HighlightWord>
    </h3>
    <p><HighlightWord words={preparedDisplayNames(vehicleMake)}>{body}</HighlightWord></p>
  </div>
);
